"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PriorityEnum;
(function (PriorityEnum) {
    PriorityEnum["PRIMARY"] = "primary";
    PriorityEnum["OUTLINE"] = "outline-primary";
    PriorityEnum["SECONDARY"] = "secondary";
    PriorityEnum["SUCCESS"] = "success";
    PriorityEnum["DANGER"] = "danger";
    PriorityEnum["WARNING"] = "warning";
    PriorityEnum["INFO"] = "info";
    PriorityEnum["NAVBAR"] = "navbar";
})(PriorityEnum || (PriorityEnum = {}));
exports.default = PriorityEnum;
